/**
 * 图片 URL 处理工具
 * 解决 HTTP 图片在 HTTPS 环境下的加载问题
 */

/**
 * 将 HTTP 图片 URL 转换为通过代理访问的 HTTPS URL
 * @param originalUrl 原始图片 URL
 * @returns 处理后的图片 URL
 */
export function convertImageUrl(originalUrl) {
  if (!originalUrl) {
    return '';
  }

  // 如果是 HTTPS URL，但实际需要 HTTP，转换为代理请求
  if (originalUrl.startsWith('https://')) {
    // 检查是否是已知的 HTTP 服务器
    const httpServers = [
      'piacinema3.xsrv.jp',
      // 添加其他需要强制使用 HTTP 的服务器
    ];
    
    try {
      const urlObj = new URL(originalUrl);
      if (httpServers.includes(urlObj.hostname)) {
        // 将 HTTPS 转换为 HTTP 并通过代理访问
        const httpUrl = originalUrl.replace('https://', 'http://');
        return convertHttpUrl(httpUrl);
      }
    } catch (error) {
      console.warn('Invalid URL format:', originalUrl);
    }
    
    return originalUrl;
  }

  // 如果是 HTTP URL，通过代理访问
  if (originalUrl.startsWith('http://')) {
    return convertHttpUrl(originalUrl);
  }

  return originalUrl;
}

/**
 * 转换 HTTP URL 为可访问的 URL
 * @param httpUrl HTTP URL
 * @returns 转换后的 URL
 */
function convertHttpUrl(httpUrl) {
  // 尝试多种代理方案
  const proxies = [
    // 方案1：使用自己的代理服务（不编码 URL）
    () => `/image-proxy?url=${httpUrl}`,
    
    // 方案2：使用公共 CORS 代理
    () => `https://cors-anywhere.herokuapp.com/${httpUrl}`,
    
    // 方案3：使用其他公共代理
    () => `https://api.allorigins.win/raw?url=${httpUrl}`,
    
    // 方案4：直接返回（可能在某些环境下工作）
    () => httpUrl,
  ];

  // 默认使用第一个方案
  return proxies[0]();
}

/**
 * 批量转换图片 URL
 * @param urls 图片 URL 数组
 * @returns 转换后的图片 URL 数组
 */
export function convertImageUrls(urls) {
  return urls.map(url => convertImageUrl(url));
}

/**
 * 检查是否为 HTTP URL
 * @param url 要检查的 URL
 * @returns 是否为 HTTP URL
 */
export function isHttpUrl(url) {
  return url && url.startsWith('http://');
}

/**
 * 检查是否为 HTTPS URL
 * @param url 要检查的 URL
 * @returns 是否为 HTTPS URL
 */
export function isHttpsUrl(url) {
  return url && url.startsWith('https://');
}